import { Category, Subcategory, SubcatType } from '@omniafishing/core';
import _ from 'lodash';
import React from 'react';
import { RouteComponentProps } from 'react-router';
import { ScrollToTop } from '../components/scroll_to_top/scroll_to_top';
import { SEO } from '../components/seo/seo';
import { SubcatTypeProductsGridContainer } from '../components/subcat_type_products_grid/subcat_type_products_grid_container';

interface SubcatTypePageProps {
  category: Category;
  subcategory: Subcategory;
  subcatType: SubcatType;
}

type Props = SubcatTypePageProps &
  RouteComponentProps<{
    subcategory: string;
  }>;

export const SubcatTypePage = (props: Props) => {
  const { category, subcategory, subcatType } = props;
  const metaTitle =
    (subcatType && subcatType.meta_title) || (subcatType && _.startCase(subcatType.display_name));
  return (
    <ScrollToTop>
      <SEO titleTemplate="%s" title={metaTitle} description={subcatType.meta_description} />
      <section>
        <SubcatTypeProductsGridContainer
          subcatType={subcatType}
          subcategory={subcategory}
          category={category}
          key={subcategory?.url_path}
        />
      </section>
    </ScrollToTop>
  );
};

export default SubcatTypePage;
